enum RoundingMode {
  Commercial = 'commercial',
  Up = 'up',
}

export default RoundingMode;
